export const featuresItIt = {
  annotations: {
    aiFeedbackAlert: {
      desktopPrompt: "Clicca con il tasto destro sulla foto per dare un feedback all'AI!",
      improveAccuracy: 'Migliora la precisione.',
      improveAccuracyFor: 'Migliora la precisione per {{tradeCompanyName}}.',
      mobilePrompt: "Tieni premuto sulla foto per dare un feedback all'AI!",
    },
    aiFeedbackSwitch: {
      label: 'Mostra feedback AI',
    },
    aiFilters: {
      analysisFailedDescription: 'Il nostro team indagherà. Nel frattempo, procedi con le foto rimanenti nel rapporto.',
      analysisFailedTitle: "L'AI non è riuscita ad analizzare questa foto",
      description: 'Mostra o nascondi i contorni del materiale e confrontali con la foto originale.',
      noFiltersDescription:
        "L'AI di Safi evidenzia solo il materiale non target (come impurità o allegati). Questa foto contiene solo materiale target (es. UBC o PET), quindi non ci sono contorni o filtri da visualizzare.",
      noFiltersTitle: 'Nessun filtro da mostrare poiché rilevato 100% materiale target',
      showOutlines: 'Mostra contorni AI',
      title: 'Regola filtri AI',
    },
    commentBubble: {
      actions: {
        deleteFeedback: 'Elimina feedback',
        edit: 'Modifica',
      },
      adminMeta: 'ID:{{commentId}} AI:{{aiVersion}}',
      deleteDialog: {
        confirm: 'Elimina',
        message: 'Sei sicuro di voler eliminare questo feedback? Questa azione non può essere annullata.',
        title: 'Elimina feedback',
      },
    },
    commentFormDrawer: {
      actions: {
        cancel: 'Annulla',
        save: 'Salva',
      },
      feedbackType: {
        incorrectDetection: 'Oggetto rilevato in modo errato',
        missingDetection: 'Oggetto non rilevato',
      },
      labels: {
        note: 'Nota',
      },
      titleCreate: "Dai un feedback all'AI",
      titleEdit: 'Modifica feedback AI',
    },
    helpAndFeedbackBar: {
      downloadFullImageAriaLabel: 'Scarica immagine completa delle prove',
    },
    segmentationOverlay: {
      ariaLabel: 'Immagine con sovrapposizione di segmentazione',
      helpText: {
        desktop: 'Passa il mouse sulla foto per ingrandire',
        mobile: 'Ingrandisci con le dita',
      },
    },
    speechBubbleAvatar: {
      viewCommentAriaLabel: 'Visualizza commento di {{fullName}}',
    },
  },
  auth: {
    companySignUpForm: {
      actions: {
        next: 'Avanti',
      },
      labels: {
        companyType: 'Tipo di azienda',
        country: 'Paese',
        name: 'Nome',
      },
      notifications: {
        errorSigningUp: 'Errore durante la registrazione',
      },
      validation: {
        companyTypeRequired: 'Il tipo di azienda è obbligatorio',
        countryRequired: 'Il paese è obbligatorio',
        nameRequired: 'Il nome è obbligatorio',
      },
    },
    otpForm: {
      actions: {
        signIn: 'Accedi',
      },
      labels: {
        passcode: 'Codice di accesso',
      },
      validation: {
        digitsOnly: 'Deve contenere solo cifre',
        passcodeLength: 'Il codice monouso deve essere di 4 cifre',
        passcodeRequired: 'Il codice monouso è obbligatorio',
      },
    },
    signInEmailForm: {
      actions: {
        next: 'Avanti',
      },
      labels: {
        email: 'Email',
      },
      links: {
        signInWithPhone: 'Accedi con il numero di telefono',
      },
      validation: {
        emailRequired: "L'email è obbligatoria",
        invalidEmail: 'Email non valida',
        termsRequired: 'Devi accettare i termini e le condizioni',
      },
    },
    signInPage: {
      subtitle:
        'Accedi a {{brandName}} con la tua email di lavoro o il numero di telefono. Ti invieremo un codice monouso per un accesso più rapido.',
      title: 'Controllo qualità con fiducia',
    },
    signInPhoneForm: {
      actions: {
        next: 'Avanti',
        signInWithEmail: 'Accedi con email',
      },
      labels: {
        phoneNumber: 'Numero di telefono',
      },
      validation: {
        phoneNumberRequired: 'Il numero di telefono è obbligatorio',
      },
    },
    termsAndPolicyAgreement: {
      fullSentence:
        "Accetto i <termsLink>Termini e Condizioni</termsLink> e l'<privacyLink>Informativa sulla Privacy</privacyLink> iscrivendomi a {{brandName}}.",
    },
    userSignUpForm: {
      actions: {
        next: 'Avanti',
      },
      labels: {
        email: 'Email',
        fullName: 'Nome completo',
        phoneNumber: 'Numero di telefono',
      },
      notifications: {
        errorSigningUp: 'Errore durante la registrazione',
      },
      validation: {
        emailRequired: "L'email è obbligatoria",
        fullNameRequired: 'Il nome completo è obbligatorio',
        invalidEmail: 'Email non valida',
        phoneNumberRequired: 'Il numero di telefono è obbligatorio',
        termsRequired: 'Devi accettare i termini e le condizioni',
      },
    },
  },
  backlog: {
    breakdowns: {
      evaluatedSpecsItems: {
        ungroupedMaterials: 'Materiali non raggruppati',
      },
      formatDirtScore: {
        average: 'Medio',
        clean: 'Pulito',
        dirty: 'Sporco',
        notAvailable: 'N/D',
        veryClean: 'Molto pulito',
      },
      materialAiBreakdown: {
        aiModelNotSupported: 'Modello AI non supportato',
      },
      materialLabels: {
        aluminium: 'Alluminio',
        aluminiumAerosol: 'Aerosol in alluminio',
        aluminiumFoodCan: 'Lattina alimentare in alluminio',
        brown: 'Marrone',
        clear: 'Trasparente',
        clearFullSleeveNonFoodGrade: 'Sleeve completo trasparente, non per uso alimentare',
        clearNonFoodGrade: 'Trasparente, non per uso alimentare',
        clearPetTray: 'Vaschetta PET trasparente',
        darkBlue: 'Blu scuro',
        dirtyBottles: 'Bottiglie sporche',
        expandedPolystyrene: 'Polistirene espanso',
        film: 'Film',
        foilAndTray: 'Foglio e vaschetta',
        fullSleeve: 'Sleeve completo',
        green: 'Verde',
        hdpe: 'HDPE',
        hdpeBlack: 'Nero',
        hdpeBlue: 'Blu',
        hdpeBrown: 'Marrone',
        hdpeGreen: 'Verde',
        hdpeJazz: 'Jazz',
        hdpeNaturalFoodGrade: 'Naturale per uso alimentare',
        hdpeNaturalNonFoodGrade: 'Naturale non per uso alimentare',
        hdpeOrange: 'Arancione',
        hdpePurple: 'Viola',
        hdpeRed: 'Rosso',
        hdpeSiliconTubes: 'Tubi in silicone',
        hdpeWhiteFoodGrade: 'Bianco per uso alimentare',
        hdpeWhiteNonFoodGrade: 'Bianco non per uso alimentare',
        hdpeYellow: 'Giallo',
        lightBlue: 'Azzurro',
        metal: 'Metallo',
        nonAluminium: 'Non alluminio',
        nonHdpe: 'Non HDPE',
        nonMetal: 'Non metallico',
        nonPet: 'Non PET',
        nonPlastic: 'Non plastica',
        oilBottle: "Bottiglia d'olio",
        opaque: 'Opaco',
        other: 'Altro',
        otherAluminium: 'Altro alluminio',
        otherColour: 'Altro colore',
        otherMetal: 'Altro metallo',
        otherPlastic: 'Altra plastica',
        pet: 'PET',
        petTrayContaminatedClear: 'Vaschetta PET trasparente contaminata',
        polypropylene: 'PP',
        prohibitive: 'Proibitivo',
        total: 'Totale',
        ubc: 'UBC',
        waste: 'Rifiuto',
        white: 'Bianco',
      },
      representativeEvidenceFilter: {
        label: 'Visualizza immagini di:',
        options: {
          bestBales: 'Balle migliori',
          typicalBales: 'Balle tipiche',
          worstBales: 'Balle peggiori',
        },
      },
      representativeEvidenceSection: {
        distributionTitle: 'Distribuzione {{targetName}}',
      },
      specificationAlerts: {
        groupDescription:
          '<boldAction>{{actionText}}</boldAction> - Il gruppo <boldName>{{name}}</boldName> è <boldComparison>{{comparison}}</boldComparison>',
        groupDescriptionWithoutComparison:
          '<boldAction>{{actionText}}</boldAction> - Il gruppo <boldName>{{name}}</boldName> è',
        groupIs: 'il gruppo è',
        the: '- Il',
        title: 'Avvisi',
      },
      totalWeightWarning: {
        message:
          'Attenzione! Il peso totale ({{formattedTotalWeight}}kg) non corrisponde alla somma dei pesi della ripartizione ({{formattedSum}}kg).',
      },
    },
    cameraGuidance: {
      useCameraStream: {
        notifications: {
          cannotUseCamera: 'Impossibile utilizzare la fotocamera',
          refreshAndAllowCamera:
            "Aggiorna questa pagina e riprova. Consenti l'accesso alla fotocamera quando richiesto.",
        },
      },
    },
    common: {
      noData: 'Nessun dato',
    },
    dealDetails: {
      fields: {
        destination: 'Destinazione',
        endProcessor: 'Trasformatore finale',
        inspections: 'Ispezioni',
        loadingSite: 'Sito di carico',
        loads: 'Carichi',
        material: 'Materiale',
        producer: 'Produttore',
        risk: 'Rischio',
      },
      header: {
        deal: 'Affare {{dealId}}',
      },
    },
    dealRevenueDetails: {
      columns: {
        description: 'Descrizione',
        id: 'ID',
        invoiceStatus: 'Stato fattura',
        invoiceXeroAmountPaid: 'Importo pagato fattura Xero',
        invoiceXeroFullyPaidOn: 'Fattura Xero pagata interamente il',
        invoiceXeroId: 'ID fattura Xero',
        lineTotal: 'Totale riga',
        quantity: 'Quantità',
        unitAmount: 'Importo unitario',
      },
    },
    documentGeneration: {
      notifications: {
        failedToSaveFile: 'Impossibile salvare il file',
        failedToUploadFile: 'Impossibile caricare il file',
      },
    },
    evidence: {
      bulkDownload: {
        empty: 'Nessuna prova da scaricare',
        error: 'Download delle prove non riuscito',
        inProgress: 'Preparazione del download…',
        partialSuccess: 'Scaricate {{downloaded}} di {{total}} foto',
        success: 'Scaricate {{count}} foto',
      },
      common: {
        editSample: 'Modifica campione',
        manageInspection: 'Gestisci ispezione',
      },
      evidencePhotosViewer: {
        bulkDeleteError: 'Impossibile eliminare le foto',
        bulkDeleteSuccess: '{{count}} foto eliminate con successo',
        noEvidenceFound: 'Nessuna foto trovata',
      },
      loadingPhotoEvidenceGallery: {
        noOtherImagesAvailable: 'Nessuna altra immagine disponibile.',
      },
      manualBreakdownFormFields: {
        kilogramUnit: 'Kg',
      },
      sessionSummary: {
        anonymous: 'Anonimo',
        withOrigin: '{{origin}} - Caricato da {{uploadedBy}}',
        withoutOrigin: 'Caricato da {{uploadedBy}}',
      },
      uploadMenu: {
        downloadAllEvidence: 'Scarica tutte le prove',
        downloadingAllEvidence: 'Download in corso…',
        editEvidence: 'Modifica prove',
        menuAriaLabel: 'Altre azioni',
        offlineModeComingSoon: 'Modalità offline in arrivo',
        openCamera: 'Apri fotocamera',
        uploadEvidence: 'Carica prove',
      },
      uploadOptionsButton: {
        actions: {
          upload: 'Carica',
        },
        options: {
          openCamera: 'Apri fotocamera',
          uploadPhoto: 'Carica foto',
        },
      },
    },
    evidenceGrid: {
      columns: {
        evidence: 'Prove',
      },
    },
    externalLoad: {
      common: {
        supplier: 'Fornitore',
      },
    },
    findTicketsTable: {
      columns: {
        category: 'Categoria',
        status: 'Stato',
        summary: 'Riepilogo',
        team: 'Team',
      },
    },
    firmQuoteBulkForm: {
      columns: {
        bunkerAdjustmentFactorCost: 'Costo fattore di adeguamento bunker',
        bunkerAdjustmentFactorCurrency: 'Valuta fattore di adeguamento bunker',
        carrier: 'Vettore',
        containerType: 'Tipo di container',
        demandIncoterm: 'Incoterm domanda',
        destinationCountry: 'Paese di destinazione',
        destinationLat: 'Lat. destinazione',
        destinationLon: 'Lon. destinazione',
        destinationName: 'Nome destinazione',
        directLandCost: 'Costo terrestre diretto',
        directLandCurrency: 'Valuta terrestre diretta',
        e2eCost: 'Costo E2E',
        e2eCurrency: 'Valuta E2E',
        estimatedDeparture: 'Partenza stimata',
        expiresOn: 'Scade il',
        forwarder: 'Spedizioniere',
        notes: 'Note',
        oceanFreightCost: 'Costo trasporto marittimo',
        oceanFreightCurrency: 'Valuta trasporto marittimo',
        onCarriageCost: 'Costo trasporto successivo',
        onCarriageCurrency: 'Valuta trasporto successivo',
        originCountry: 'Paese di origine',
        originLat: 'Lat. origine',
        originLon: 'Lon. origine',
        originName: 'Nome origine',
        peakSeasonSurchargeCost: 'Costo supplemento alta stagione',
        peakSeasonSurchargeCurrency: 'Valuta supplemento alta stagione',
        portOfDischarge: 'POD',
        portOfLoading: 'POL',
        preCarriageCost: 'Costo pre-trasporto',
        preCarriageCurrency: 'Valuta pre-trasporto',
        quotedOn: 'Quotato il',
        supplyIncoterm: 'Incoterm offerta',
        typeOfGoods: 'Tipo di merce',
      },
    },
    grade: {
      compositionReport: {
        annotatedBaleAlt: 'Balla annotata',
      },
      imageQualityPrompt: {
        label: 'Ripeti scatto',
      },
    },
    groundControl: {
      common: {
        descriptions: {
          calculateDealProfitability: "Calcola la redditività dell'affare",
          createPurchaseOrderAndSendToSeller: 'Crea un ordine di acquisto e invialo al venditore per la firma',
          createSalesOrderAndSendToBuyer: "Crea un ordine di vendita e invialo all'acquirente per la firma",
          viewEditAndMatch: 'Visualizza, modifica e abbina',
        },
        labels: {
          createPurchaseOrder: 'Crea ordine di acquisto',
          createSalesOrder: 'Crea ordine di vendita',
          dealProfitabilityCalculator: 'Calcolatore redditività affare',
          viewPurchaseOrders: 'Visualizza ordini di acquisto',
          viewSalesOrders: 'Visualizza ordini di vendita',
        },
      },
      tabs: {
        advanced: {
          label: 'Avanzate',
          links: {
            addExternalEvidence: {
              description: 'Aggiungi prove da fonti esterne',
              label: 'Aggiungi prove esterne',
            },
            manageMaterialProducts: {
              description: 'Visualizza e modifica i prodotti materiali',
              label: 'Gestisci prodotti materiali',
            },
            pernType: {
              description: 'Aggiorna i tipi PERN',
              label: 'Tipo PERN',
            },
          },
        },
        contracts: {
          label: 'Contratti',
        },
        deals: {
          label: 'Affari',
          links: {
            goToDealHub: {
              description: 'Visualizza e gestisci le attività degli affari',
              label: 'Vai al DealHub',
            },
            viewAllDeals: {
              description: 'Visualizza e modifica tutti gli affari e i carichi',
              label: 'Visualizza tutti gli affari',
            },
          },
        },
        finance: {
          label: 'Finanza',
          links: {
            createShippingRate: {
              description: 'Crea una tariffa di spedizione e tutti i dettagli associati',
              label: 'Crea tariffa di spedizione',
            },
            manageBanks: {
              description: 'Visualizza e modifica i dettagli bancari',
              label: 'Gestisci banche',
            },
            manageCosts: {
              description: 'Crea, modifica e visualizza i costi',
              label: 'Gestisci costi',
            },
            manageExternalCompanies: {
              description: 'Crea, modifica e visualizza i dettagli delle aziende esterne',
              label: 'Gestisci aziende esterne',
            },
            manageFinancing: {
              description: 'Invia richieste di pagamento a Finmid',
              label: 'Gestisci finanziamenti',
            },
            manageRevenue: {
              description: 'Crea, modifica e visualizza i ricavi',
              label: 'Gestisci ricavi',
            },
            marketPernPrices: {
              description: 'Visualizza i prezzi storici PERN da T2E',
              label: 'Prezzi PERN di mercato',
            },
          },
        },
        support: {
          label: 'Supporto',
          links: {
            getSupport: {
              description: 'Crea un ticket di supporto Jira',
              label: 'Ottieni supporto',
            },
            helpAndLearn: {
              description: 'Guide di aiuto',
              label: 'Aiuto e formazione',
            },
          },
        },
        trade: {
          label: 'Commercio',
          links: {
            generateDocuments: {
              description: 'Genera documenti per ordini di acquisto, ordini di vendita, spedizioni, ecc.',
              label: 'Genera documenti',
            },
            transportMetabase: {
              description: 'Link a Transport Metabase',
              label: 'Transport Metabase',
            },
          },
        },
        usersAndCompanies: {
          label: 'Utenti e aziende',
          links: {
            copySessions: {
              description: 'Copia le sessioni nel test di precisione ML da un caricamento CSV',
              label: 'Copia sessioni',
            },
            createUserAndCompany: {
              description: "Crea un utente e una nuova azienda, o invita in un'azienda esistente",
              label: 'Crea utente e azienda',
            },
            hijackUser: {
              description: 'Accedi rapidamente come un altro utente',
              label: 'Impersona un utente',
            },
            staffOnboarding: {
              description: 'Crea un nuovo utente amministratore e rendilo membro di Safi',
              label: 'Onboarding personale',
            },
            viewTradeCompanies: {
              description: 'Visualizza e modifica le aziende commerciali di domanda e offerta',
              label: 'Visualizza tutte le aziende commerciali',
            },
          },
        },
      },
    },
    guidePriceChip: {
      label: 'Prezzo indicativo',
      unavailable: 'Prezzo indicativo non disponibile',
    },
    helpGuides: {
      aiBale: {
        partOne: {
          boldText: 'Stai a 1 metro al massimo',
          imageAlt: 'Stai a 1 metro al massimo',
          trailingText: 'davanti alla pila.',
        },
      },
      aiLoose: {
        partFour: {
          and: 'e',
          clearPile: 'Rimuovi la pila',
          imageAlt: 'Rimuovi pila',
          repeatSteps: 'ripeti i passaggi 1-3',
          untilText: "finché non hai scattato una foto per pila per l'intero campione.",
        },
        partOne: {
          imageAlt: 'Crea una pila',
          makePile: 'Crea una pila',
          middleText: 'dal tuo campione e stendila uniformemente sul pavimento.',
          takePhoto: 'Scatta 1 foto per pila.',
        },
        partThree: {
          boldIntro: 'Controlla la foto prima di rimuovere la pila.',
          imageAlt: 'Rivedi ed elimina',
          trailingText: 'Se non è corretta, puoi eliminarla e scattarne una nuova.',
          warningBold: 'Solo 1 foto per pila',
          warningPrefix: 'Carica',
          warningSuffix: "per evitare di alterare i risultati dell'AI.",
        },
      },
      common: {
        completeAlt: 'Completato',
      },
      data: {
        guides: {
          aiBale: 'AI Balla',
          aiBriquette: 'AI Brichetta',
          aiLoose: 'AI Sfuso',
          emailSupport: 'Scrivici a support@safi.co',
        },
        sections: {
          contactSupport: 'Contatta il supporto',
          qualityControlGuides: 'Guide al controllo qualità',
        },
        subcategories: {
          emailSupportPrompt: 'Hai bisogno di supporto o vuoi richiedere una nuova funzionalità?',
          howToTakeGreatAiPhotos: "Come scattare ottime foto per l'AI",
        },
      },
    },
    manageDataButton: {
      buttonLabel: 'Gestisci dati',
      options: {
        aiBalePhotos: 'Foto AI balle',
        loadingEvidence: 'Prove di caricamento',
        marketingMedia: 'Media marketing',
        samples: 'Campioni',
        siteEvidence: 'Prove del sito',
        specifications: 'Specifiche',
      },
    },
    materialCategoryActions: {
      notifications: {
        cannotSaveMaterial: 'Impossibile salvare il materiale',
        errorCreatingMaterial: 'Errore nella creazione del materiale',
        errorDeletingMaterial: "Errore nell'eliminazione del materiale",
        errorSavingMaterial: 'Errore nel salvataggio del materiale',
        savedSuccessfully: 'Salvato con successo',
        selectedTargetGroupHasNoOperands:
          'Il gruppo target selezionato non ha operandi. Scegli un altro gruppo target.',
        skippedSpecifications: '{{count}} specifica/e non salvata/e perché non hanno operandi assegnati.',
      },
    },
    materialComponents: {
      supportedComponentList: {
        buttonText: 'Aggiungi componente materiale',
        title: 'Componenti materiale',
      },
    },
    materialDirtLevel: {
      options: {
        clean: 'Pulito',
        dirty: 'Sporco',
        notAvailable: 'N/D',
        veryClean: 'Molto pulito',
      },
    },
    materialProducts: {
      validation: {
        atLeastOneBuyerMaterialComponentIsRequired: "È richiesto almeno un componente materiale dell'acquirente.",
        atLeastOneSellerMaterialComponentIsRequired: 'È richiesto almeno un componente materiale del venditore.',
        buyerAndSellerMaterialComponentCountsMustMatch:
          "Il numero dei valori dei componenti materiale dell'acquirente e del venditore deve essere uguale.",
      },
    },
    materialProductsList: {
      columns: {
        buyerMaterialComponents: 'Componenti materiale acquirente',
        capsAndLabels: 'Tappi ed etichette',
        country: 'Paese',
        foodGrade: 'Per uso alimentare',
        id: 'ID',
        materialGrade: 'Grado del materiale',
        materialOrigin: 'Origine del materiale',
        materialSpec: 'Specifica del materiale',
        process: 'Processo',
        sellerMaterialComponents: 'Componenti materiale venditore',
      },
      values: {
        no: 'No',
        notSpecified: 'N/D',
        yes: 'Sì',
      },
    },
    notificationParty: {
      label: 'Parte da notificare',
      options: {
        allViaAgent: 'Tutte le comunicazioni tramite agente',
        directWithBuyer: "Comunica direttamente con l'acquirente",
      },
    },
    orders: {
      validation: {
        fixedPriceAndDateMustBeProvidedTogether: 'Il prezzo fisso e la data fissa devono essere forniti insieme',
      },
    },
    paymentMethod: {
      label: 'Metodo di pagamento',
      options: {
        documentAgainstPayment: 'Documenti contro pagamento',
        telegraphicTransfer: 'Bonifico telegrafico',
      },
    },
    percentageLightBlue: {
      label: 'Percentuale azzurro',
      options: {
        notAvailable: 'N/D',
      },
    },
    siteMaterials: {
      notifications: {
        errorCreatingMaterial: 'Errore nella creazione del materiale',
        materialCreated: 'Materiale creato',
        productLinkedSuccessfully: 'Prodotto collegato con successo',
      },
    },
    timeFilter: {
      options: {
        last30Days: 'Ultimi 30 giorni',
        last7Days: 'Ultimi 7 giorni',
        last90Days: 'Ultimi 90 giorni',
        next14Days: 'Prossimi 14 giorni',
        next2Days: 'Prossimi 2 giorni',
        next7Days: 'Prossimi 7 giorni',
      },
    },
    variablePricingFields: {
      indexOptions: {
        lmeAluminium: 'LME Alluminio',
        lmeAluminiumMidwestPremium: 'LME Alluminio + Midwest Premium',
      },
    },
  },
  breakdowns: {
    adminAiVersionTitle: {
      value: 'AI:{{version}}',
    },
    aiSampleBreakdown: {
      analysisNotAvailable: 'Analisi non disponibile',
    },
    aluMaterialSampleBreakdown: {
      labels: {
        aluminium: 'Alluminio',
        foilAndTray: 'Foglio e vaschetta',
        foodCan: 'Lattina alimentare',
        nonAluminium: 'Non alluminio',
        nonMetal: 'Non metallico',
        otherAluminium: 'Altro alluminio',
        otherMetal: 'Altro metallo',
        total: 'Totale',
        ubc: 'UBC',
      },
    },
    analysisInProgressAlert: {
      partialDescription:
        'I risultati qui sotto si basano su {{acceptedCount}} foto su {{submittedCount}}. Altre {{pendingCount}} sono ancora in fase di analisi.',
      partialTitle: 'Altre foto sono in fase di analisi',
      pendingDescription:
        '{{pendingCount}} foto su {{submittedCount}} sono ancora in fase di analisi. I risultati dovrebbero comparire entro pochi minuti.',
      pendingTitle: 'Analisi in corso',
      photoPendingDescription:
        'La foto è ancora in fase di analisi in background. Risultati e contorni dovrebbero comparire entro pochi minuti.',
      rejectedDescription: '{{rejectedCount}} foto sono state rifiutate. Controlla il motivo su ogni foto.',
    },
    cleanliness: {
      label: 'Pulizia',
      tooltip:
        'La pulizia è una misura di quanto è pulito il materiale. Varia da molto pulito, pulito, medio e sporco. Lo sporco include grasso, macchie e polvere presenti sulla superficie del materiale.',
    },
    evaluatedSpecsBreakdown: {
      customizeTableFor: 'Personalizza la tabella per',
      targetChip: 'Target',
      thisMaterial: 'questo materiale',
      title: 'Analisi AI',
    },
    noAnalysisAlert: {
      description:
        "L'AI non è riuscita ad analizzare le foto. Puoi controllare il motivo su ogni foto, eliminare quelle rifiutate e riprovare.",
      guidance:
        'Consulta la <guideLink>guida {{guideLabel}}</guideLink> per suggerimenti su come scattare foto migliori.',
      noSubmittedPhotosDescription:
        "Non sono ancora state inviate foto per l'analisi. Aggiungi foto per avviare l'analisi.",
      title: 'Nessun risultato disponibile',
    },
    petFlake: {
      fields: {
        bulkDensity: 'Densità apparente',
        clearFlakes: 'Scaglie trasparenti',
        colouredFlakes: 'Scaglie colorate',
        darkBlueFlakes: 'Scaglie blu scuro',
        ferrousMetal: 'Metallo ferroso',
        glue: 'Colla',
        greenFlakes: 'Scaglie verdi',
        intrinsicViscosity: 'Viscosità intrinseca',
        isophthalicAcid: 'Acido isoftalico',
        lightBlueFlakes: 'Scaglie azzurre',
        meltFlowRate: 'Indice di fluidità (MF) (260°C/2,16Kg)',
        meltingPoint: 'Punto di fusione',
        nonFerrousMetal: 'Metallo non ferroso',
        otherImpurities: 'Altre impurità',
        paper: 'Carta',
        particlesSizeBetween10And12mm: 'Particelle con dimensione tra 10 e 12 mm',
        particlesSizeBetween5And10mm: 'Particelle con dimensione tra 5 e 10 mm',
        particlesSizeLt5mm: 'Particelle con dimensione < 5 mm',
        petContent: 'Contenuto di polietilene tereftalato (PET)',
        ph: 'pH',
        polyolefinContamination: 'Contaminazione da poliolefine',
        pvcContamination: 'Contaminazione da PVC',
        residualContamination: 'Contaminazione residua',
        residualMoisture: 'Umidità residua',
        sampledBy: 'Campionato da',
        woodenMaterials: 'Materiali in legno',
        yellowFlakes: 'Scaglie gialle',
      },
    },
    petMaterialSampleBreakdown: {
      labels: {
        clear: 'Trasparente',
        clearFullSleeveNonFoodGrade: 'Sleeve completo trasparente, non per uso alimentare',
        clearNonFoodGrade: 'Trasparente, non per uso alimentare',
        clearPetTray: 'Vaschetta PET trasparente',
        darkBlue: 'Blu scuro',
        film: 'Film',
        green: 'Verde',
        largeClear5L: 'Trasparente grande (≥5L)',
        lightBlue: 'Azzurro',
        liquid: 'Liquido',
        nonPetBottle: 'Bottiglia non PET',
        nonPlastic: 'Non plastica',
        other: 'Altro',
        otherPlastic: 'Altra plastica',
        petBottle: 'Bottiglia PET',
        prohibitive: 'Proibitivo',
        total: 'Totale',
      },
    },
    taintTaborMaterialSampleBreakdown: {
      labels: {
        aluIron: 'Allu./ferro',
        aluNonMetal: 'Allu./non metallico',
        aluWithAttachments: 'Allu. con allegati',
        aluminium: 'Alluminio',
        cast: 'Fusione',
        castIron: 'Fusione/ferro',
        ferrousMetal: 'Metallo ferroso',
        finesLt20mm: 'Fini <20mm',
        nonAluminium: 'Non alluminio',
        nonMetal: 'Non metallico',
        otherMetal: 'Altro metallo',
        prohibitive: 'Proibitivo',
        radiatorCondenser: 'Radiatore/Condensatore',
        stainlessSteel: 'Acciaio inossidabile',
        taintTabor: 'Taint Tabor',
        total: 'Totale',
        ubcFoil: 'UBC/Foglio',
      },
    },
    zorbaMaterialSampleBreakdown: {
      labels: {
        aluminiumUbc: 'Alluminio - UBC',
        compositeMaterials: 'Materiali compositi',
        copperBrassRedsYellows: "Rame e ottone - 'rossi e gialli'",
        finesLt20mm: 'Fini <20mm',
        nonFerrousMetalWhites: "Metallo non ferroso - 'bianchi'",
        nonTarget: 'Non target',
        otherMetalFerrous: 'Altro metallo (ferroso)',
        otherNonMetal: 'Altro non metallico',
        postConsumerAluminiumPackaging: 'Imballaggio in alluminio post-consumo',
        prohibitive: 'Proibitivo',
        targetMaterial: 'Materiale target',
        total: 'Totale',
      },
    },
  },
  cameraGuidance: {
    camera: {
      notifications: {
        autoCaptureOff: 'Acquisizione automatica disattivata',
        autoCaptureOn: 'Acquisizione automatica attivata',
      },
      rejectedPhotos: {
        message: "Tocca la foto qui sotto per vedere il motivo dell'errore, poi elimina la foto e riprova",
        photo: 'foto',
        photos: 'foto',
        title: '{{prefix}} per controllare {{count}} {{countLabel}}!',
        titlePrefixObfuscated: 'Fallito',
        titlePrefixWithAi: "L'AI ha fallito",
      },
    },
    cameraFooter: {
      actions: {
        capture: 'Scatta',
        complete: 'Completa',
        guide: 'Guida',
      },
      tooltips: {
        takePhotoToComplete: 'Scatta una foto per completare',
      },
    },
    cameraHeader: {
      autoCapture: 'Acquisizione automatica',
      confirmationDialog: {
        actions: {
          complete: 'Completa',
          exitAnyway: 'Esci comunque',
        },
        messageWithAiLabel:
          'Le tue foto verranno salvate ma non vedrai i risultati AI subito. Per visualizzare il rapporto AI ora, tocca Completa.',
        messageWithoutAiLabel:
          'Le tue foto verranno salvate ma non vedrai i risultati subito. Per visualizzare il rapporto ora, tocca Completa.',
        title: 'Uscire dalla fotocamera?',
      },
      flashAriaLabel: 'Attiva o disattiva il flash',
      settings: {
        description: 'Usa la modalità offline se la connessione dati è debole per evitare di perdere le foto',
        title: 'Impostazioni',
      },
    },
    countdownOverlay: {
      snap: 'Scatto!',
    },
    previewImageReview: {
      actions: {
        deleteAndRetake: 'Elimina e ripeti scatto',
      },
      evidencePhotoAlt: 'Foto delle prove',
      notifications: {
        deleteFailed: 'Non è stato possibile eliminare questa foto. Riprova.',
      },
    },
  },
  charts: {
    targetBaleWeightsHistogram: {
      axes: {
        x: '% contenuto target previsto',
        y: 'Numero di balle',
      },
      labels: {
        average: 'Media: {{targetGrade}}%',
        bales: 'Balle',
      },
      tooltip: {
        label: '% rilevata: {{label}}',
        value: '{{value}} balle',
      },
    },
  },
  dataCards: {
    aluminiumComposition: {
      reportTitle: 'Rapporto',
      targetDistributionTitle: 'Distribuzione target',
    },
    common: {
      loads: 'Carichi',
      metricTonnes: 'Tonnellate metriche',
    },
    hdpeComposition: {
      aiBaleAnalysisTitle: 'Analisi AI balle',
      reportTitle: 'Rapporto',
    },
    loadingDetails: {
      actions: {
        showMedia: 'Mostra media',
      },
      fields: {
        loadingNotes: 'Note di caricamento',
        loadingTechnique: 'Tecnica di caricamento',
        packedOn: 'Confezionato il',
        targetPayload: 'Carico utile target',
      },
      title: 'Dettagli di caricamento',
      values: {
        targetPayloadMt: '{{targetPayload}} (MT)',
      },
    },
    materialNotAnalysed: {
      analysisTitle: 'Analisi',
      noResultsDescription:
        'Non abbiamo ancora costruito un modello per questo tipo specifico di materiale. Con più dati, saremo in grado di fornire analisi in futuro.',
      noResultsTitle: 'Nessun risultato disponibile',
      reportTitle: 'Rapporto',
    },
    materialSpecifications: {
      actions: {
        showMedia: 'Mostra media',
      },
      analysis: {
        completed: 'Completata',
        notCompleted: 'Non completata',
      },
      fields: {
        baleDimensions: 'Dimensioni balla',
        capsAndLabels: 'Tappi ed etichette',
        density: 'Densità (kg/m³)',
        ferrousCheck: 'Controllo ferroso',
        foodGrade: 'Per uso alimentare',
        materialAnalysisNotes: 'Note analisi materiale',
        materialForm: 'Forma del materiale',
        materialProcess: 'Processo del materiale',
        origin: 'Origine',
        radiationCheck: 'Controllo radiazioni',
        strapping: 'Reggettatura',
        visualCheck: 'Controllo visivo',
      },
      title: 'Specifiche del materiale',
      units: {
        meters: 'm',
      },
      values: {
        no: 'No',
        yes: 'Sì',
      },
    },
    petComposition: {
      aiBaleAnalysisTitle: 'Analisi AI balle',
      reportTitle: 'Rapporto',
    },
    site: {
      actions: {
        showMedia: 'Mostra media',
      },
      fields: {
        machinesUsed: 'Macchinari utilizzati',
        materialOrigin: 'Origine del materiale',
        monthlyVolume: 'Volume mensile',
        siteGround: 'Terreno del sito',
        siteNotes: 'Note del sito',
        storageAndCover: 'Stoccaggio e copertura',
      },
      monthlyVolumeValue: '{{productionVolume}} (MT)',
      title: 'Sito',
    },
    tradeCompanySessionLoose: {
      aiLooseAnalysisTitle: 'Analisi AI sfuso',
      reportTitle: 'Rapporto',
      sampleTotalWeightTitle: 'Peso totale campione',
    },
    transactionHistory: {
      alerts: {
        newSupplier: 'Nuovo fornitore! Non hai ancora acquistato da loro.',
        purchasedBefore: 'Hai già acquistato da questo fornitore!',
      },
      title: 'Storico transazioni',
      total: {
        description: 'Transazioni tra questo fornitore e altri acquirenti negli ultimi 6 mesi.',
      },
    },
  },
  error: {
    actions: {
      contactSupport: 'Contatta il supporto',
      goToHomepage: 'Vai alla home',
      tryAgain: 'Riprova',
    },
    forbidden: {
      description: 'Non hai i permessi per visualizzare questa pagina.',
      title: 'Accesso negato',
    },
    generic: {
      description: 'Si è verificato un errore imprevisto. Riprova.',
      title: 'Qualcosa è andato storto',
    },
    network: {
      description: 'Controlla la tua connessione a internet e riprova.',
      title: 'Sembra che tu sia offline',
    },
    notFound: {
      description: 'Non siamo riusciti a trovare la pagina che cerchi.',
      title: 'Pagina non trovata',
    },
    server: {
      description: 'Stiamo riscontrando problemi a raggiungere i nostri server. Riprova tra un momento.',
      title: 'Qualcosa è andato storto',
    },
    support: {
      body: 'Ho riscontrato un errore e ho bisogno di aiuto.\n\nPagina: {{url}}\nDettagli: {{detail}}\n\nCosa stavo facendo:',
      subject: 'Safi Quality — Ho bisogno di aiuto con un errore',
    },
  },
  evidence: {
    actionBar: {
      deletePrompt: 'Sei sicuro di voler eliminare le prove selezionate?',
      deleteTitle: 'Elimina {{evidence}}',
      selectedCount: '{{selected}} selezionati',
    },
    chips: {
      ai: 'AI',
      selfServe: 'Self-Serve',
    },
    defaultBreakdownFormFields: {
      actions: {
        addBreakdownItem: 'Aggiungi elemento di ripartizione',
      },
      labels: {
        name: 'Nome',
        unit: 'Unità',
        value: 'Valore',
      },
      title: 'Ripartizione',
    },
    editForm: {
      actions: {
        delete: 'Elimina',
        edit: 'Modifica',
      },
      labels: {
        newEvidenceType: 'Nuovo tipo di {{evidence}}',
        newLabel: 'Nuovo',
        typeLabel: 'Tipo',
      },
      notifications: {
        deleteError: "Errore nell'eliminazione delle prove",
        deleteSuccess: 'Prove eliminate',
        updateError: "Errore nell'aggiornamento delle prove",
        updateSuccess: 'Prove aggiornate',
      },
      validation: {
        typeOrSiteMaterialRequired: 'È necessario fornire il tipo di prova o il materiale del sito',
      },
      warnings: {
        deleteMessage:
          'Stai per eliminare questa prova da questo materiale del sito. Verrà rimossa dal rapporto di qualità associato. Conferma per continuare.',
        editMessage:
          'Stai per modificare questa prova. Verrà rimossa dal rapporto di qualità associato. Conferma per continuare.',
        title: 'Attenzione!',
      },
    },
    inspectionSessionDetails: {
      labels: {
        dealId: 'ID affare:',
        inspectionSlug: 'Slug ispezione:',
      },
      tooltips: {
        reportAvailableOnCompletion: "Una volta completata l'ispezione, troverai qui un link al rapporto.",
        searchInDrive: "Cerca l'ispezione in Google Drive",
        viewDealDetails: "Visualizza dettagli dell'affare",
        viewExternalReport: 'Visualizza rapporto esterno',
      },
    },
    offlineGallery: {
      notifications: {
        cachedClearError: 'Impossibile cancellare le foto memorizzate',
        cachedClearSuccess: 'Foto memorizzate cancellate',
        cachedSyncError: 'Impossibile sincronizzare le foto memorizzate',
        cachedSyncSuccess: "Foto caricate. L'analisi potrebbe richiedere alcuni minuti per completarsi.",
        clearError: 'Impossibile cancellare le prove offline',
        clearSuccess: 'Prove offline cancellate con successo',
        missingParentViewCache:
          'Una o più foto memorizzate appartengono a un report che non esiste più. Apri le foto memorizzate per scaricarle e ricaricarle oppure eliminarle.',
      },
      title: '{{evidenceLower}} offline',
      tooltips: {
        cannotSyncWithoutInternet: 'Impossibile sincronizzare senza una connessione Internet',
        clear: 'Cancella prove offline',
        sync: 'Sincronizza prove offline',
        syncInProgress: 'Sincronizzazione in corso...',
      },
    },
    sampleBreakdown: {
      labels: {
        aiBreakdown: 'Ripartizione AI',
        manualBreakdown: 'Ripartizione manuale',
        noNotes: 'Nessuna nota',
        sample: 'Campione',
        sampleEvidence: 'Prove del campione',
      },
      totalWeight: '{{totalWeight}}kg',
    },
    sampleFormFields: {
      breakdowns: {
        alu: {
          groups: {
            aluminium: 'Alluminio',
            nonAluminium: 'Non alluminio',
          },
          items: {
            foilAndTray: 'Foglio e vaschetta',
            foodCan: 'Lattina alimentare',
            nonMetal: 'Non metallico',
            otherAluminium: 'Altro alluminio',
            otherAluminiumAerosols: 'Altro alluminio (aerosol)',
            otherMetal: 'Altro metallo',
            rigidPlastics: 'Plastiche rigide',
            ubc: 'UBC',
            vapes: 'Vapes',
          },
        },
        pet: {
          groups: {
            otherPetAndPlastics: 'Altro PET e plastiche',
            petBottles: 'Bottiglie PET',
          },
          items: {
            clear: 'Trasparente',
            clearFullSleeve: 'Trasparente (Sleeve completo)',
            clearLarge: 'Trasparente (Grande)',
            clearPetTray: 'Vaschetta PET trasparente',
            darkBlue: 'Blu scuro',
            film: 'Film',
            green: 'Verde',
            lightBlue: 'Azzurro',
            liquid: 'Liquido',
            nonFoodGradeBottle: 'Bottiglia PET non per uso alimentare',
            nonPlastic: 'Non plastica',
            other: 'Altro',
            otherPlastic: 'Altra plastica',
            prohibitive: 'Proibitivo',
          },
        },
        taintTabor: {
          groups: {
            aluWithAttachments: 'Allu. con allegati',
            aluminium: 'Alluminio',
            nonAluminium: 'Non alluminio',
          },
          items: {
            aluIron: 'Allu./ferro',
            aluNonMetal: 'Allu./non metallico',
            cast: 'Fusione',
            castIron: 'Fusione/ferro',
            ferrousMetal: 'Metallo ferroso',
            finesLt20mm: 'Fini <20mm',
            nonMetal: 'Non metallico',
            otherMetal: 'Altro metallo',
            prohibitive: 'Proibitivo',
            radiatorCondenser: 'Radiatore/Condensatore',
            stainlessSteel: 'Acciaio inossidabile',
            taintTabor: 'Taint Tabor',
            ubcFoil: 'UBC/Foglio',
          },
        },
        zorba: {
          groups: {
            nonTarget: 'Non target',
            targetMaterial: 'Materiale target',
          },
          items: {
            aluminiumFoilUbc: 'Alluminio - foglio / UBC',
            compositeMaterials: 'Materiali compositi',
            copperAndBrass: "Rame e ottone 'rossi e gialli'",
            finesLt20mm: 'Fini <20mm',
            nonFerrousMetal: "Metallo non ferroso 'bianchi'",
            otherMetalFerrous: 'Altro metallo (ferroso)',
            otherNonMetal: 'Altro non metallico',
            postConsumerAluminiumPackaging: 'Imballaggio in alluminio post-consumo',
            prohibitive: 'Proibitivo',
          },
        },
      },
      labels: {
        notes: 'Note',
        totalWeight: 'Peso totale',
        weightUnit: 'Kg',
      },
    },
    sampleMaterialEditForm: {
      actions: {
        edit: 'Modifica',
      },
      warning: {
        editMessage:
          'Stai per modificare questa prova. Verrà rimossa dal rapporto di qualità associato. Conferma per continuare.',
        title: 'Attenzione!',
      },
    },
    sampleSessionDetails: {
      manualSampleAnalysisTitle: 'Analisi campione manuale',
      noData: 'Nessun dato',
      sampleImagesTitle: 'Immagini del campione',
    },
    sessionStats: {
      excludedSubtitle: 'Le immagini non hanno superato i nostri requisiti',
      excludedTitle: 'Escluse',
      includedSubtitle: 'Le immagini hanno superato i nostri requisiti',
      includedTitle: 'Incluse',
    },
    unloadingPhotoUploader: {
      label: 'Carica foto',
      notifications: {
        uploadFailed: 'Caricamento fallito',
        uploadSuccess: 'Caricamento riuscito',
      },
    },
  },
  helpGuides: {
    aiBale: {
      partTwo: {
        captions: {
          clearWhichBaleToFocusOn: 'Chiaro su quale balla concentrarsi',
          goodQualityPhoto: 'Foto di buona qualità',
          goodQualityPhotoAndDistanceFromBale: 'Foto di buona qualità e distanza dalla balla',
          greatDistanceFromBale: 'Ottima distanza dalla balla',
          materialNotTooTightlyPacked: 'Materiale non troppo compresso',
          materialTooFlatAndTightlyPacked: 'Materiale troppo piatto e compresso',
          nearlyAllBaleFaceShown: 'Quasi tutta la faccia della balla è visibile',
          photoTooBlurry: 'Foto troppo sfocata',
          someBackgroundIsOk: "Un po' di sfondo va bene",
          tooClose: 'Troppo vicino',
          tooManyBalesAngleNotStraightPoorQuality: 'Troppe balle, angolazione non frontale, scarsa qualità',
          tooManyBalesManySidesVisible: 'Troppe balle, molti lati visibili',
          tooManyBalesTooFarAway: 'Troppe balle, troppo lontano',
          unclearWhichIsMainBale: 'Non chiaro quale sia la balla principale',
        },
        intro: 'Ecco esempi di foto buone e cattive:',
      },
    },
    aiBriquette: {
      partOne: {
        imageAlt: 'Stai a 0,5 metri al massimo',
        instructions: '<bold>Stai a 0,5 metri</bold> davanti alla brichetta.',
      },
      partTwo: {
        analysisInstruction: 'Quando analizzi un pallet, <bold>scatta foto di almeno 6 brichette.</bold>',
        captions: {
          goodDistance: 'Buona distanza',
          markingsVisible: 'Marcature visibili',
          noMarkingsVisible: 'Nessuna marcatura visibile',
          okDistance: 'Distanza accettabile',
          tooDirty: 'Troppo sporco',
          tooShredded: 'Troppo sminuzzato',
        },
        intro: 'Ecco esempi di foto buone e cattive:',
      },
    },
    aiLoose: {
      partTwo: {
        captions: {
          cannotSeeAllMaterial: 'Non si vede tutto il materiale',
          floorHasLargeMarkings: 'Il pavimento ha grandi marcature',
          materialInsideBlackBox: 'Il materiale è dentro il riquadro nero',
          materialNotOnGroundOrTable: 'Il materiale non è sul pavimento/tavolo',
          materialShouldNotTouchPurpleLines: 'Il materiale non deve toccare le linee viola',
          materialSpreadVeryWell: 'Materiale steso molto bene',
          materialSpreadWell: 'Materiale steso bene',
          materialTouchesEdge: 'Il materiale tocca il bordo',
          shadow: 'Ombra',
          squareFullOfMaterial: 'Il quadrato è pieno di materiale',
          tooHeapedAndTooBig: 'Troppo ammucchiato e troppo grande',
        },
        intro: 'Ecco esempi di foto buone e cattive:',
      },
    },
    alert: {
      actions: {
        startGuide: 'Inizia guida - 1 min',
      },
      description: {
        obfuscatedAi: 'Leggi questa breve guida per scattare le foto giuste.',
        withAi:
          'Leggi questa breve guida per scattare le foto giuste per risultati AI accurati. Foto cattive = risultati cattivi.',
      },
      title: 'Prima volta con {{modelTitle}}?',
    },
    autoCaptureTip: {
      message:
        'Suggerimento! Vai più veloce e tieni i guanti con <autoCapture>Acquisizione automatica</autoCapture> che scatta automaticamente le foto per te.',
    },
    common: {
      actions: {
        back: 'Indietro',
        finish: 'Fine',
        next: 'Avanti',
        skipGuide: 'Salta guida',
      },
      models: {
        bale: 'balla',
        briquette: 'brichetta',
      },
    },
    complete: {
      message:
        "Quando hai finito, tocca <complete>'Completa'</complete> nella fotocamera. Vedrai poi il <qualityReport>Rapporto di qualità.</qualityReport>",
    },
    dialog: {
      stepLabel: 'Passo {{currentStep}}/{{maxSteps}}',
      title: 'Benvenuto in {{modelTitle}}!',
    },
    guideTitle: {
      obfuscatedAi: 'Impara a scattare foto correttamente per ottenere i migliori risultati.',
      withAi: 'Impara a scattare foto correttamente per ottenere i migliori risultati AI.',
    },
    offlineWarning: {
      message:
        'Suggerimento! Attiva la <offlineMode>Modalità offline</offlineMode> per evitare di perdere le foto quando la connessione dati è debole.',
    },
    reviewDeleteHelpText: {
      withAi:
        "Puoi vedere se una {{model}} è stata <accepted>accettata</accepted> o <rejected>rifiutata</rejected> dall'AI. <delete>Elimina</delete> e <retake>ripeti lo scatto</retake> delle foto errate.",
      withoutAi:
        'Puoi vedere se una {{model}} è stata <accepted>accettata</accepted> o <rejected>rifiutata</rejected>. <delete>Elimina</delete> e <retake>ripeti lo scatto</retake> delle foto errate.',
    },
    reviewDeleteTip: {
      message:
        'Suggerimento! Puoi anche <reviewDelete>rivedere, eliminare</reviewDelete> e <addMorePhotos>aggiungere altre foto</addMorePhotos> nel Rapporto di qualità.',
    },
  },
  instructions: {
    photoInstructionsDrawer: {
      actions: {
        doNotShowAgain: 'Non mostrare più',
        takePhoto: 'Scatta foto',
      },
      description:
        'La nostra AI analizza le immagini caricate su più parametri. Le immagini caricate dovrebbero apparire come quelle qui sotto.',
      frontFaceDescription:
        "La causa più comune di un'immagine non valida è l'orientamento della balla. Gli oggetti nella balla devono essere appiattiti e frontali.",
      frontFaceTitle: "Cos'è la faccia frontale?",
      imageAlt: {
        balePhotoExample: 'Esempio di foto balla',
        frontFaceBalePhoto: 'Foto balla faccia frontale',
        treeRingBalePhoto: 'Foto balla ad anelli',
      },
      labels: {
        objectsFlattenedFaceOn: 'Oggetti appiattiti e frontali',
        objectsSquashedSideOn: 'Oggetti schiacciati e laterali',
      },
      title: 'Come scattare le foto',
    },
  },
  materialComponents: {
    supportedComponent: {
      labels: {
        materialComponent: 'Componente materiale',
      },
    },
    supportedComponentValue: {
      adornments: {
        max: 'Max: ',
        min: 'Min: ',
      },
      labels: {
        booleanValue: 'Valore booleano',
        value: 'Valore',
      },
    },
  },
  nativeCachedPhotos: {
    notifications: {
      syncFailed: {
        description: 'Sono salvate sul telefono. Spostati in un luogo con segnale migliore, poi sincronizza di nuovo.',
        message: {
          few: '{{failedCount}} foto non sono state caricate',
          many: '{{failedCount}} foto non sono state caricate',
          one: '{{failedCount}} foto non è stata caricata',
          other: '{{failedCount}} foto non sono state caricate',
        },
      },
    },
  },
  navigation: {
    sidebar: {
      closeAriaLabel: 'Chiudi',
    },
    userMenu: {
      belowSpecLoadEmailAlert: 'Carico sotto specifica',
      buyerEvidenceRequestCompletedEmailAlert: 'Invito partner completato',
      dailyProductionSummary: 'Riepilogo giornaliero della produzione',
      dailyQualityDigest: 'Report qualità giornaliero',
      emailNotificationsEnabled: 'Notifiche abilitate',
      language: 'Lingua',
      logOut: 'Esci',
      manageCompany: 'Gestisci azienda',
      notifications: 'Email di notifica',
      weeklyQualityDigest: 'Report qualità settimanale',
    },
  },
  networkStatus: {
    alert: {
      offlineMessage: 'Sei attualmente offline, le prove verranno salvate localmente fino al ritorno online.',
    },
    override: {
      label: 'Modalità offline',
      notifications: {
        disabled: 'Modalità offline disattivata',
        enabled: 'Modalità offline attivata',
      },
    },
  },
  offlinePhotosAlert: {
    all: 'tutte',
    cacheDialog: {
      close: 'Chiudi',
      delete: 'Elimina',
      deleteError: 'Impossibile eliminare la foto memorizzata',
      deleteMessage: 'Questa azione eliminerà definitivamente questa foto memorizzata e non può essere annullata.',
      deleteSuccess: 'Foto memorizzata eliminata',
      deleteTitle: 'Elimina foto memorizzata',
      description:
        'Controlla le foto memorizzate, scarica quelle che devi conservare ed elimina quelle che non devono essere sincronizzate.',
      download: 'Scarica',
      downloadUnavailable: 'La foto non è disponibile per il download',
      empty: 'Nessuna foto memorizzata trovata.',
      nativeLoading: "Caricamento delle foto memorizzate nell'app...",
      orderRef: 'Riferimento ordine: {{orderRef}}',
      parentDeleted: 'Report eliminato',
      parentUnavailableDescription:
        'Può succedere se qualcuno della tua azienda ha eliminato una sessione vuota da un altro account. Eliminale oppure scaricale e ricaricale nel report corretto.',
      parentUnavailableTitle: 'Queste foto memorizzate non hanno più un report',
      parentVerificationFailed: 'Impossibile verificare la disponibilità del report. Riprova più tardi.',
      previewLoading: 'Caricamento anteprima...',
      previewUnavailable: 'Anteprima non disponibile',
      reportId: 'Report: {{parentId}}',
      supplier: 'Fornitore: {{supplier}}',
      takenAt: 'Scattata il: {{takenAt}}',
      title: 'Foto memorizzate',
    },
    cancel: 'Annulla',
    deleteAction: 'Elimina {{photoNoun}}',
    deleteMessage: 'Questa azione eliminerà definitivamente le foto e non può essere annullata.',
    deleteTitle: 'Elimina foto',
    descriptionWithAi: "Sincronizza {{photoNoun}} per abilitare l'analisi AI e renderle visibili ad altri utenti.",
    descriptionWithoutAi: "Sincronizza {{photoNoun}} per abilitare l'analisi e renderle visibili ad altri utenti.",
    it: 'essa',
    notifications: {
      cachedClearError: 'Impossibile cancellare le foto memorizzate',
      cachedClearSuccess: 'Foto memorizzate cancellate',
      cachedSyncError: 'Impossibile sincronizzare le foto memorizzate',
      cachedSyncSuccess: "Foto caricate. L'analisi potrebbe richiedere alcuni minuti per completarsi.",
      clearError: 'Impossibile cancellare le foto offline',
      clearSuccess: 'Foto offline cancellate',
      syncOfflineEvidenceError: 'Impossibile sincronizzare le evidenze offline',
      syncPartialFailure: '{{successCount}} foto sincronizzate, {{failedCount}} non riuscite',
      syncSuccess: '{{successCount}} foto sincronizzate',
      uploadError: 'Impossibile caricare le foto offline',
    },
    photo: 'foto',
    photoIs: 'foto è',
    photos: 'foto',
    photosAre: 'foto sono',
    syncAction: 'Sincronizza {{photoNoun}}',
    syncingMessage: 'Sincronizzazione foto in corso. Potrebbe richiedere del tempo...',
    them: 'esse',
    title: '{{count}} {{pluralVerb}} offline in attesa di sincronizzazione',
    viewPhotos: 'Visualizza foto',
  },
  omnisearch: {
    noOptions: {
      withValue: 'Nessun risultato trovato',
      withoutValue: 'Digita per cercare',
    },
    placeholder: {
      desktop: 'Ctrl/Cmd + K per cercare',
      mobile: 'Cerca',
    },
  },
  siteMaterial: {
    tradeCompanySiteMaterialPicker: {
      actions: {
        addNewMaterial: 'Aggiungi nuovo materiale',
        addNewMaterialAriaLabel: 'Aggiungi nuovo materiale',
      },
      labels: {
        company: 'Azienda',
        siteMaterial: 'Materiale del sito',
      },
    },
  },
} as const;
